import React from 'react';
import logger from '../global/logger';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    logger.warning(error.message);
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <div className="message-box message-box--error">
            <span className="message-box__icon">
              <i className="far fa-exclamation-circle" aria-hidden="true" />
            </span>
            <p>
              {this.props.message
                ? this.props.message.there_has_been_an_error
                : 'Sorry, there has been an error'}
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
